import {
  type BranchKey,
  configurationKeys,
  useInvalidateAllConciseBranches,
} from '@festina-life/api'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import {
  fetchAllBranchChangesetsKeyPrefix,
  fetchMetaModelKeyPrefix,
} from '../api/keys'

export const useInvalidateBranchAfterHistoryRewrite = () => {
  const queryClient = useQueryClient()
  const invalidateBranches = useInvalidateAllConciseBranches()
  return useCallback(
    async (branchKey: BranchKey) => {
      await queryClient.invalidateQueries({
        queryKey: [
          configurationKeys.fetchBranchAllErrorsPrefix({
            branchName: branchKey.name ?? '',
            server: branchKey.server,
          }),
        ],
      })

      await queryClient.invalidateQueries({
        queryKey: fetchAllBranchChangesetsKeyPrefix({
          branchName: branchKey.name,
          componentName: branchKey.server,
          isFromConfigurationServer: true,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: configurationKeys.fetchConciseBranchKeyPrefix({
          branchName: branchKey.name,
          server: branchKey.server,
        }),
      })

      await queryClient.invalidateQueries({
        queryKey: fetchMetaModelKeyPrefix({
          server: branchKey.server,
          branch: branchKey.name,
        }),
      })

      await invalidateBranches()
    },
    [invalidateBranches, queryClient],
  )
}
